/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const AirplaneIcon = ({
  title = 'Airplane',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M7.54 15.542l-6.319-1.718C.057 13.507-.126 11.95.897 11.36l.072-.038L19.71 1.878c.963-.63 2.217.25 2.058 1.32v14.189c0 .848-.771 1.477-1.592 1.324l-.077-.017-6.433-1.589-2.692 4.556c-.639 1.082-2.28.777-2.487-.462l-.947-5.657zm.946-2.533l-3.17-.862 8.174-4.12-5.004 4.982zm10.59-5.058l-3.98 6.734 3.98.982V7.951zm-5.178 3.47l-3.365 5.694-.337-2.01 3.702-3.685z" />
  </CreateIconComponent>
);

export default AirplaneIcon;
